import {message as antdMessage} from "antd";

export const message = {
    success(msg) {
        antdMessage.destroy(); //销毁
        antdMessage.success(msg);
    },
    error(msg) {
        antdMessage.destroy();
        antdMessage.error(msg);
    },
    info(msg) {
        antdMessage.destroy();
        antdMessage.info(msg);
    },
    warning(msg) {
        antdMessage.destroy();
        antdMessage.warning(msg);
    },
    destroy(){
        antdMessage.destroy();
    }
};